import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgFire(props: RootSvgProps) {
  return (
    <RootSvg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2506_21102)">
        <path
          d="M4.375 12.5C4.375 13.2986 4.54427 14.0582 4.88281 14.7786C5.22135 15.4991 5.69444 16.1372 6.30208 16.6927C6.28472 16.6059 6.2717 16.5191 6.26302 16.4323C6.25434 16.3455 6.25 16.2587 6.25 16.1719C6.25 15.7031 6.33681 15.2648 6.51042 14.8568C6.68403 14.4488 6.9184 14.0799 7.21354 13.75L10 10.625L12.7865 13.75C13.0816 14.0972 13.316 14.4748 13.4896 14.8828C13.6632 15.2908 13.75 15.7205 13.75 16.1719C13.75 16.2587 13.7457 16.3498 13.737 16.4453C13.7283 16.5408 13.7153 16.6319 13.6979 16.7187C14.3056 16.2153 14.7786 15.5946 15.1172 14.8568C15.4557 14.1189 15.625 13.3333 15.625 12.5C15.625 11.6146 15.4731 10.7422 15.1693 9.88281C14.8655 9.02344 14.4271 8.22917 13.8542 7.5C13.559 7.69097 13.2509 7.83854 12.9297 7.94271C12.6085 8.04687 12.2569 8.09896 11.875 8.09896C10.9722 8.09896 10.178 7.82118 9.49219 7.26562C8.80642 6.71007 8.37674 5.98958 8.20312 5.10417C7.57812 5.67708 7.03125 6.26302 6.5625 6.86198C6.09375 7.46094 5.69444 8.07292 5.36458 8.69792C5.03472 9.32292 4.78733 9.9566 4.6224 10.599C4.45747 11.2413 4.375 11.875 4.375 12.5ZM10 13.4375L8.61979 15C8.46354 15.191 8.34201 15.3863 8.25521 15.5859C8.1684 15.7856 8.125 16.0069 8.125 16.25C8.125 16.7708 8.30729 17.2135 8.67187 17.5781C9.03646 17.9427 9.47917 18.125 10 18.125C10.5208 18.125 10.9635 17.9427 11.3281 17.5781C11.6927 17.2135 11.875 16.7708 11.875 16.25C11.875 16.0069 11.8316 15.7812 11.7448 15.5729C11.658 15.3646 11.5365 15.1736 11.3802 15L10 13.4375ZM10 1.25V4.34896C10 4.86979 10.1823 5.3125 10.5469 5.67708C10.9115 6.04167 11.3542 6.22396 11.875 6.22396C12.1701 6.22396 12.4436 6.16319 12.6953 6.04167C12.947 5.92014 13.1597 5.74653 13.3333 5.52083L13.75 5C14.8611 5.65972 15.7639 6.68837 16.4583 8.08594C17.1528 9.48351 17.5 10.9549 17.5 12.5C17.5 14.5833 16.7708 16.3542 15.3125 17.8125C13.8542 19.2708 12.0833 20 10 20C7.91667 20 6.14583 19.2708 4.6875 17.8125C3.22917 16.3542 2.5 14.5833 2.5 12.5C2.5 10.5556 3.15972 8.58941 4.47917 6.60156C5.79861 4.61372 7.63889 2.82986 10 1.25Z"
          fill="#E867A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_2506_21102">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="matrix(0 -1 1 0 0 20)"
          />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
